var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18px",
  height: "13px",
  viewBox: "0 0 18 13",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mobile-start",
  transform: "translate(-336.000000, -10.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Budicon-Outline/Arrows/arrow-right",
  transform: "translate(336.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.4800002,9.49533057 C17.4800002,9.59613124 17.4400424,9.69281932 17.36866,9.76399057 L12.04866,15.0839906 C11.899556,15.228 11.6625478,15.2259405 11.5159689,15.0793616 C11.3693901,14.9327828 11.3673306,14.6957745 11.51134,14.5466706 L16.18268,9.87533057 L1.14,9.87533057 C0.930131795,9.87533057 0.76,9.70519877 0.76,9.49533057 C0.76,9.28546236 0.930131795,9.11533057 1.14,9.11533057 L16.18268,9.11533057 L11.51134,4.44399057 C11.3673306,4.29488659 11.3693901,4.05787835 11.5159689,3.91129951 C11.6625478,3.76472067 11.899556,3.76266113 12.04866,3.90667057 L17.36866,9.22667057 C17.4400424,9.29784181 17.4800002,9.39452989 17.4800002,9.49533057 Z",
  id: "Shape"
}))))));
export default SvgArrowRight;